import React, { useRef, useEffect, useState } from "react";

import "../assets/css/NotFound.css";

import * as THREE from "three";
import { Canvas, useLoader, useFrame } from "@react-three/fiber";
import { OrbitControls, Environment } from "@react-three/drei";
import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader";
import { MTLLoader } from "three/examples/jsm/loaders/MTLLoader";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import greenBallObj from "../assets/objects/green-ball.obj";
import greenBallMtl from "../assets/objects/green-ball.mtl";
import skyEnv from "../assets/environments/sky_env.hdr";

gsap.registerPlugin(ScrollTrigger);

function NotFound() {
    const marker = false;

    // LOADING OBJ AND MTL 
    const materials = useLoader(MTLLoader, greenBallMtl);
    const model = useLoader(OBJLoader, greenBallObj, (loader) => {
        loader.setMaterials(materials);
    });

    const modelRef = useRef(null);
    const canvasRef = useRef(null);
    const cameraRef = useRef(null);
    const containerRef = useRef(null);

    useEffect(() => {
        if (canvasRef.current) {
            // Access the camera from the Canvas
            const { camera } = canvasRef.current;
            // Save to ref for later use
            cameraRef.current = camera;
            // Set initial state for the camera using GSAP
            gsap.set(camera, {
                x: 0,
                y: 0,
                z: 5, // Initial Z position
            });
            const cameraTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: containerRef.current,
                    start: "top top",
                    end: "30% top",
                    scrub: 1,
                    markers: marker,
                },
            });
            // Example GSAP animation for ScrollTrigger
            cameraTimeline.to(camera, {
                x: 5, // Animate to new X position
                y: -50,
                z: 5, // Animate to new Z position
                duration: 3,
                // onUpdate: () => camera.updateProjectionMatrix(), // Update projection matrix
            });
        }
        // CLEAN UP SCROLL TRIGGER ON COMPONENT UNMOUNT 
        return () => {
            ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
        };
    }, []);

    // // Use GSAP to trigger the rotation on scroll
    // useEffect(() => {
    //     // Create the ScrollTrigger animation
    //     gsap.to(canvasRef.current.rotation, {
    //         x: Math.PI * 2, // Rotate 360 degrees on X-axis
    //         y: Math.PI * 2, // Rotate 360 degrees on Y-axis
    //         scrollTrigger: {
    //             trigger: ".canvas-container", // Target the container where scroll is happening
    //             start: "top top", // Start animation at the top of the container
    //             end: "bottom bottom", // End animation at the bottom of the container
    //             scrub: true, // Scrub through the animation based on scroll
    //             markers: false, // Optionally show markers for debugging
    //         },
    //     });

    //     return () => {
    //         // Clean up ScrollTrigger when component unmounts
    //         ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
    //     };
    // }, []); // Depend on `isReady` state

    useEffect(() => {
        if (model) {
            model.scale.set(1, 1, 1); // Scale the model to a reasonable size
            model.position.set(0, 0, 0); // Center the model
        }
    }, [model]);


    return (
        <>
            <div className="canvas-container fixed w-[100vw] h-[100vh]">
                <Canvas
                    ref={canvasRef}
                    camera={{
                        // position: [0, 0, 5],
                        // position: [0, -50, 5], // Adjust the Z position for scaling
                        fov: 50, // Field of View for consistent scaling
                    }}
                    gl={{
                        toneMapping: THREE.ACESFilmicToneMapping
                    }}
                    gammaOutput
                >
                    <ambientLight intensity={0.8} />
                    {/* FRONT LIGHT  */}
                    <directionalLight
                        position={[0, 10, 10]}
                        intensity={1}
                    />
                    {/* BACK LIGHT  */}
                    <directionalLight
                        position={[0, -10, -10]}
                        intensity={1}
                    />

                    <spotLight
                        position={[0, 0, 0]}
                        angle={0.3}
                        penumbra={1}
                        intensity={1.5}
                        castShadow
                    />

                    {/* Render the ball model and environment */}
                    <primitive
                        object={model}
                        ref={modelRef}
                    />
                    {/* Environment for background */}
                    {/* <Environment preset="sunset" background /> */}
                    <Environment
                        // ref={envRef}
                        files={skyEnv}
                        background
                    />

                    <OrbitControls
                        enableZoom={false}
                        enablePan={false}
                    />
                </Canvas>
            </div>
            {/* DUMMY CONTAINER */}
            <div
                ref={containerRef}
                className="h-[300vh] bg-[#5a7090]"
            >
                SPACE FOR SCROLL TRIGGER
            </div>
        </>
    );
}

export default NotFound;
